/**
 * Created by yqr on 2018/4/13.
 * 设置api请求的baseURL
 * 实际项目中建议该文件不纳入版本管理
 */
export default {
  // baseURL: 'https://apitest.xingchaoyiqing.com',
  baseURL: 'https://s.xingchaoyiqing.com',      // 国内版
  // baseURL: 'https://apihw.fenshen123.com',  // 海外版站点
  isDev: false
}




// WEBPACK FOOTER //
// ./src/api/env.js